import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
// table(components)
import BoostrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import {
  CreateTooltip,
  DicomStatusHeader,
  FileUploadStatus,
  GetHeaderStyle,
  GetImageStduyStatus,
  PostJson,
  getCellStyle,
} from "../../core/Helper";
import { ThaiDate } from "../../core/ThaiDate";
import "./style.css";
import { WsCmmdContext, WsContext } from "../../App";
import XrayImage from "../../images/x-ray.png";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";
import FileSaver from "file-saver";
import { atob } from "js-base64";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { StudyService } from "../../model/study";
import styled from "styled-components";
import { BiRefresh } from "react-icons/bi";
import {
  // Circles,
  Oval,
  // Rings,
  // SpinningCircles,
  // TailSpin,
} from "react-loading-icons";
import ConfirmDialogB from "../components/ConfirmDialogB";

export default function StudyHistories(props) {
  // props called from RadioResult
  const [data, setData] = props.data;
  const [history, setHistory] = useState([]);
  const [editor, setEditor] = props.editor;
  const [selectItem, setSelectItem] = props.selectedItem;

  const theme = useSelector((s) => s.theme.theme);
  const userDetail = props.userDetail;
  const [ws, setWs] = useContext(WsContext);
  const [fileOpener, setFileOpener] = props.winState;
  const [wsCmd, setWsCmd] = useContext(WsCmmdContext);
  const [defaultRow, setDefaultRow] = useState(5);
  const [showOld, setShowOld] = props.showOldParam;
  const [loadingHist, setLoadingHist] = useState(false);
  const [confirm, setConfirm] = useState({ show: false, action: () => {} });

  /** download options */
  const [dwProgress, setDwlProgress, dwShow, setDwShow, dwText, setDwText] =
    props.dwState;

  const dispatch = useDispatch();

  /** Add Listener for CustomeEvent From */
  /** Effect WsCommand */
  // useEffect(() => {
  //   document.addEventListener("wscalling", getWsMsg);
  //   return () => {
  //     document.removeEventListener("wscalling", getWsMsg);
  //   };
  // }, [wsCmd]);

  useEffect(() => {
    if (editor?.show) {
      getHistory();
      return () => {
        setHistory([]);
      };
    }
  }, [data]);

  // useEffect(() => {
  //   getHistory();
  //   return () => {
  //     setHistory([]);
  //   };
  // }, []);

  //** Counter เพื่อ Refresh สถานะเคสเก่า */
  /*
  const [counter, setCounter] = useState(1);
  useEffect(() => {
    // console.log("STUDY HIST INTERVAL TEST STARTED.");
    let intervalId = setInterval(() => {     
      setCounter(counter + 1);
    }, 10000);

    console.log("COUNTER", counter);
    return () => {
      clearInterval(intervalId);
      console.log("Interval Closed");
    };
  }, [counter]);
  */

  const getHistory = async () => {
    // console.log(data);
    if (!data) return;
    setLoadingHist(true);
    let his = await StudyService.GetHistory({
      StudyInfo: {
        pacs_study_id: data.studyInfo?.pacs_study_id,
        study_instance_uid: data.studyInfo?.study_instance_uid,
      },
      UserInfo: userDetail,
    });

    setHistory(his);
    setLoadingHist(false);
  };

  /**Handler web-socket command corresponding with this page*/

  /** --------------------------------------------------------------- */
  const actionPriceChange = async (oldValue, newValue, row, column, done) => {
    row.total = newValue * row.price;
    done();
  };
  /** --------------------------------------------------------------- */

  const sendRequestImage = (row, fileStatus) => {
    // * Send Websocket command
    // * 32201 = open folder or viewer app

    //console.log(row);

    setFileOpener({
      show: true,
      imageOnServerStatus: row.upload_status, // 1: uploaded, 3: deleted
      action: (res) => {
        if (row.upload_status == FileUploadStatus.Uploaded) {
          //download file...
          downloads(row);
        } else if (row.upload_status == FileUploadStatus.Deleted) {
          // ขอ upload
          requestReUpload(row);
        }
        //elseif(row.upload_status == FileUploadStatus.WaitReUpload) {}
      },
      serviceEnabled: ws != null ? true : false,
    });
  };

  /**Test progress bar  */
  const downloadss = (row) => {
    setDwlProgress(0);
    setDwShow(true);
    let i = 0;
    const interval = setInterval(() => {
      if (i < 100) {
        i++;
        setDwlProgress(i);
        setDwText(i);
      } else {
        cc();
      }
    }, 50);
    const cc = () => {
      clearInterval(interval);
      setDwlProgress(0);
      setDwShow(false);
    };
  };

  // useEffect(() => {}, [dwShow]);

  const downloads = async (row) => {
    let ret = await StudyService.CheckFileReadyToDownload({ StudyInfo: row });

    if (ret.result == true) {
      const url =
        process.env.REACT_APP_API +
        "api/studyinfo/getstudy?suid=" +
        row.study_instance_uid;
      const link = document.createElement("a");
      link.target = "_self";
      link.download = link.href = url;
      link.click();
    } else {
      setConfirm({
        show: true,
        title: (
          <div
            style={{
              background: "#000000",
              color: "#11f811",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <div>ไม่พบไฟล์ Zip คนไข้ที่ต้องการ download</div>
            <div>
              ท่านต้องการแจ้งเตือนเพื่อ{" "}
              <span style={{ color: "#ffffff" }}> Upload ภาพใหม่ </span>หรือไม่
            </div>
            <div>กรุณายืนยัน</div>
          </div>
        ),
        action: (e) => {
          if (e === true) {
            requestReUpload(row);
          }
        },
      });

      // dispatch(
      //   setReminder({
      //     show: true,
      //     message: "ไม่พบไฟล์ที่ต้องการ Download",
      //     type: "error",
      //   })
      // );
    }
  };

  const requestReUpload = async (row) => {
    let ret = await StudyService.RequestOldStudyFile({
      StudyInfo: {
        pacs_study_id: row.pacs_study_id,
        study_instance_uid: data.studyInfo.study_instance_uid,
      },
      UserInfo: { userid: userDetail.userid },
    });

    if (ret != null) {
      dispatch(
        setReminder({
          show: true,
          message: "แจ้งการขอ upload ไฟล์ไปที่ Server เรียบร้อยแล้ว",
          type: "success",
        })
      );
      getHistory();
    }
  };

  /**Dowload by Post method */
  const postDownload = (row) => {
    var api =
      process.env.REACT_APP_API + "api/studyinfo/download-study-from-api";

    dispatch(
      setReminder({
        show: true,
        message: "กำลังโหลดไฟล์\r\n กรุณารอสักครู่..",
        type: "success",
      })
    );

    // setLoading(true);
    setDwlProgress(0);
    setDwShow(true);
    axios
      .post(
        api,
        {
          StudyInfo: {
            pacs_study_id: row.pacs_study_id,
            study_instance_uid: data.studyInfo.study_instance_uid,
          },
          UserInfo: userDetail,
        },
        {
          onDownloadProgress: (e) => {
            let loaded = Math.round((e.loaded / e.total) * 100);
            setDwlProgress(loaded);
            setDwText(loaded);
          },
        },
        {
          responseType: "blob",
          // "arraybuffer",  "blob", "stream"
        },
        // HttpJsonHeader
        { headers: { "Content-Type": "application/octet-stream" } }
      )
      .then((res) => {
        // console.log(res.data);
        // console.log(res.data.length);

        /**Normal way */
        // const link = document.createElement("a");
        // // link.target = "_blank";
        // link.target = "window.loacation.href";
        // link.download = data.studyInfo.patients_name + ".zip";
        // link.href = URL.createObjectURL(
        //   new Blob([res.data], { type: "application/zip" })
        // );
        // link.click();

        /** Use liblary fileSaver */
        let filename = data.studyInfo.patients_name + ".zip";
        FileSaver.saveAs(
          new Blob([res.data], { type: "application.zip" }),
          filename
        );
        setDwShow(false);
        setDwlProgress(0);
      })
      .catch((e) => {
        setDwShow(false);
      });
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setSelectItem(row);
    },
    onDoubleClick: (e, row, rowIndex) => {
      setShowOld({ show: true, action: (e) => console.log(e) });
    },
  };

  const formatStatus = (cell, row) => {
    return <GetImageStduyStatus id={row.action_id} />;
  };

  const fontName = "tahoma";
  const fontSize = "12px";

  const columns = [
    {
      dataField: "pacs_study_id",
      hidden: true,
    },
    {
      dataField: "study_date",
      text: "วันที่",
      // sort: true,
      headerStyle: GetHeaderStyle("90px"),
      style: getCellStyle("left", null, fontSize, fontName),
      editable: true,
      formatter: (cell, row) => {
        return <ThaiDate dateValue={cell} />;
      },
    },
    {
      dataField: "modality",
      text: "Modality",
      // sort: true,
      headerStyle: GetHeaderStyle("80px", "left"),
      style: getCellStyle("center", null, fontSize, fontName),
      editable: true,
    },
    {
      dataField: "item_name",
      text: "รายการ",
      // sort: true,
      headerStyle: GetHeaderStyle("auto", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      editable: false,
    },
    {
      dataField: "brchshort",
      text: "ส่งจาก",
      // sort: true,
      headerStyle: GetHeaderStyle("auto", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      editable: false,
    },
    // {
    //   dataField: "physician",
    //   text: "แพทย์เจ้าของไข้",
    //   // sort: true,
    //   headerStyle: GetHeaderStyle("auto", "left"),
    //   style: () => getCellStyle("left", null, "18px", "niramit"),
    //   editable: false,
    // },
    {
      dataField: "physician",
      text: "อ่านผลโดย",
      // sort: true,
      headerStyle: GetHeaderStyle("auto", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      editable: false,
    },
    {
      dataField: "action_event",
      text: "สถานะ",
      headerStyle: () => GetHeaderStyle("140px"),
      style: getCellStyle("left", null, fontSize, fontName),
      formatter: formatStatus,
      align: "center",
      editable: false,
    },

    {
      dataField: "upload_stutus",
      text: (
        <RefrshButtonContainer>
          {CreateTooltip(
            "Click to Refresh",
            <RefreshButton onClick={() => getHistory()}>
              {loadingHist ? (
                <Oval
                  style={{ height: "20px", width: "20px", color: "#14f539" }}
                />
              ) : (
                <>
                  File
                  <BiRefresh size={20} />
                </>
              )}
            </RefreshButton>,
            "top"
          )}
        </RefrshButtonContainer>
      ),
      headerStyle: GetHeaderStyle("100px"),
      style: getCellStyle("center"),
      editable: false,
      formatter: (cell, row) => {
        return CreateTooltip(
          "File Upload",
          DicomStatusHeader(cell, row, null, sendRequestImage, "top")
        );
      },
    },
  ];

  const selectRow = {
    mode: "radio",
    clickToSelect: false,
    // classes: "row-h-over-selected",
    hideSelectColumn: true,
    selected: [data?.studyInfo?.pacs_study_id],
    style: {
      // backgroundImage: "linear-gradient(0deg, #3e3ea1 0%, #310f66 80% )",
      backgroundImage:
        "linear-gradient(0deg, var(--table-selected-backcolor) 0%, var(--table-selected-backcolor) 80% )",
    },
  };

  /** --------------------------------------------------------------- */
  return (
    <div>
      <BoostrapTable
        // ref={refTb}
        bootstrap4
        keyField="pacs_study_id"
        // data={data?.studyHistory != null ? data.studyHistory : []}
        data={history}
        rowClasses={"table-next-rows-style"}
        columns={columns}
        striped
        hover
        condensed
        headerWrapperClasses="table-radi-result-wrapper"
        headerClass="table-radi-result-header"
        wrapperClasses="table-radi-result-wrapper"
        bordered={true}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
          beforeSaveCell: actionPriceChange,
        })}
        selectRow={selectRow}
        rowEvents={rowEvents}
      />
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
    </div>
  );
}

const styles = {
  imgButton: {
    width: "30px",
    height: "30px",
    cursor: "pointer",
    "&:hover": { border: "1px solid #454500" },
  },
};

const RefreshButton = styled.div`
  display: flex;
  /* color: #666966; */
  //flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  padding-inline: 5px;
  padding-block: 2px;
  /* background: #221f4e; */
  :hover {
    color: #12e70b;
    background: black;
  }
`;

const RefrshButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
`;
